/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Scan } from '../models/Scan';
import type { ScanDownloadURL } from '../models/ScanDownloadURL';
import type { ScanProperties } from '../models/ScanProperties';
import type { SurfaceModel } from '../models/SurfaceModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BiometricService {
    /**
     * Get a list of all scans.
     * Get a list of all scans bs sessionID.
     * @param sessionId
     * @returns Scan The list of the requested scans.
     * @throws ApiError
     */
    public static biometricControllerGetScans(
        sessionId: string,
    ): CancelablePromise<Array<Scan>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/biometric/scans/{sessionID}/getScans',
            path: {
                'sessionID': sessionId,
            },
        });
    }
    /**
     * @returns string
     * @throws ApiError
     */
    public static biometricControllerGetScanUploadUrl(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/biometric/scans/file/upload_url',
        });
    }
    /**
     * Get an existing 3D scan model.
     * Get an existing 3D scan model by ID and encoding.
     * @param scanId
     * @param encoding
     * @returns SurfaceModel Loaded Surface Model
     * @throws ApiError
     */
    public static biometricControllerGet3DScanSurfaceModel(
        scanId: string,
        encoding?: string,
    ): CancelablePromise<SurfaceModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/biometric/scans/{scanID}/get3DScanSurfaceModel',
            path: {
                'scanID': scanId,
            },
            query: {
                'encoding': encoding,
            },
            errors: {
                404: `Surface Model Not Found`,
            },
        });
    }
    /**
     * Get the properties of a previous 3D scan.
     * Get the properties of a previous 3D scan by ID.
     * @param scanId
     * @returns ScanProperties The requested 3D scan properties.
     * @throws ApiError
     */
    public static biometricControllerGet3DScanProperties(
        scanId: string,
    ): CancelablePromise<ScanProperties> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/biometric/scans/properties/{scanID}',
            path: {
                'scanID': scanId,
            },
        });
    }
    /**
     * Get DownloadURL to upload your scan.
     * Get DownloadURL to upload your scan.
     * @param measurementId
     * @returns ScanDownloadURL The requested DownloadURL.
     * @throws ApiError
     */
    public static biometricControllerGetScanDownloadUrl(
        measurementId: string,
    ): CancelablePromise<ScanDownloadURL> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/biometric/scans/{measurementID}/download',
            path: {
                'measurementID': measurementId,
            },
            errors: {
                403: `User is not allowed to make this request.`,
                404: `When the given measurement ID was not found.`,
                412: `When the upload of the scan file was not completed.`,
                422: `Unprocessable Entity`,
                500: `Internal server error.`,
            },
        });
    }
}
